<template>
  <div class="position-absolute container-fluid d-flex flex-column justify-content-between p-0 w-100 h-100" id="postEditor">
    <Loading v-if="loadingStatus || loadingVideo" :text="'Carregando'" />

    <div
      v-if="getInDraggable"
      @mouseover="scrollUp"
      class="on-draggable up"
    >
      <i class=" fa fa-lg fa-arrow-up"></i>
    </div>

    <div
      v-if="getInDraggable"
      @mouseover="scrollDown"
      class="on-draggable down"
    >
      <i class="fa fa-lg fa-arrow-down"></i>
    </div>

    <preview-modal @savePost="stepSave()" :postId="postId" :siteId="siteId" :postIsPublished="postIsPublished" />
    <div v-if="showMediaManager">
      <media-manager
        :picsInGallery="activeContent"
        @receiveMedias="addPictures($event)"
        @dataVideo="addVideo($event)"
        @closeTabs="closeTabs()"
        :type="'image-video'"
        :maxItemSelected="this.maxItemSelected"
      />
    </div>

    <template v-else>
      <sidebar-settings
        :configsReference="configsReference"
        :activeItem="activeSettingsItem"
        :indexItem="activeSettingsItemIndex"
        :indexPageFrame="postBarSlotIndex"
        :indexChild="activeSettingsItemChildIndex"
        @updateItemActive="updateItemActive"
        @transformInGallery="transformInGallery"
      />

      <div class="container-step d-flex align-items-start mt-3">
        <div
          id="previousStep"
          class="col-auto pointer py-2 item-settings-button"
          @click="previousStep()"
          :style="saving ? 'pointer-events: none' : ''"
        >
          <b-tooltip target="previousStep" placement="bottom">
            Voltar
          </b-tooltip>
          <i class="fal fa-chevron-left"></i>
        </div>
        <div class="position-absolute w-100" style="display: flex; justify-content: center; align-items: center; top: 0; left: 0;">
            <div class="saveDisplay" v-if="savingLoading">
                <span v-if="step < 3" class="save-step-text py-1 px-3">{{
                    savingLoading
                }}</span>
            </div>
        </div>
        <div class="d-flex">
          <div id="configPost">
            <span
              v-if="this.postType == 'post' && this.step == 1"
              class="item-settings-button"
              @click="nextStep()"
              :style="saving ? 'pointer-events: none' : ''"
            >
              <i class="fal fa-cog"></i>
            </span>
          </div>

          <b-tooltip target="configPost" placement="bottom">
            Configurações de Post
          </b-tooltip>
          <div v-if="postIsPublished" class="col-auto">
                <open-design-btn
                  @openDesign.once="saveSketchEditor"
                  :siteId="siteId"
                  :postId="postId"
                  :isAutoSaving="saving"
                />
          </div>
          <!-- botao preview -->
          <div class="col-auto pointer">
            <button
              @click="openPreview"
              v-if="step == 1"
              :disabled="saving"
              class="btn-preview btn btn-primario py-2 px-4"
            >
              Preview
            </button>
          </div>
          <!-- botao salvar -->
          <div class="col-auto pointer" @click="stepSave()">
            <button
              v-if="step == 1 && nextStepText"
              :disabled="saving"
              class="next-step-text btn btn-primario py-2 px-4"
            >
              {{ nextStepText }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="total-post-editor flex-column align-items-center"
        v-show="step === 1"
        :key="1"
      >
        <div class="container-editor mb-6">
          <!-- CARDS OF SECTIONS -->
          <div
            v-for="(contentPostItem, index) in contentPost"
            :key="`${contentPostItem.frameId}-${index}`"
            :id="`${contentPostItem.frameId}-${index}`"
            class="position-relative"
          >
            <div class="editor-wrapper">
              <!-- CARD HEADER -->
              <div class="w-100 card-settings d-flex justify-content-end">
                <!-- Botão de configurações -->
                <div class="container-setting-button position-relative">
                  <button
                    class="item-settings-button"
                    v-if="contentPostItem.component.includes('maincontent-')"
                    @click="openSettingsPageFrame(
                      {...contentPostItem, backgroundColorDefault: getColorBackgroundSection(index, null)},
                      index
                    )"
                  >
                    <i class="fal fa-paint-brush"></i>
                  </button>

                  <div v-if="validadeSettingsExtra(contentPostItem)" class="alert-settings"></div>
                </div>

                <!-- BOTÃO SUBIR SEÇÃO (ORDENAR) -->
                <button
                  v-if="index != 0"
                  :disabled="sortingRules(index, 'up')"
                  v-b-tooltip.hover
                  title="Subir seção"
                  class="item-settings-button"
                  @click="handlePositionChangeSection(contentPostItem, index, 'up')"
                >
                  <i class="fal fa-angle-up"></i>
                </button>

                <!-- BOTÃO DESCER SEÇÃO (ORDENAR) -->
                <button
                  v-if="index != 0"
                  :disabled="sortingRules(index, 'down')"
                  v-b-tooltip.hover
                  title="Descer seção"
                  class="item-settings-button"
                  @click="handlePositionChangeSection(contentPostItem, index, 'down')"
                >
                  <i class="fal fa-angle-down"></i>
                </button>

                <!-- BOTÃO REMOVER CARD -->
                <button
                  :disabled="updatePostEditorStatus"
                  v-b-tooltip.hover
                  title="Remover seção"
                  v-if="index != 0 && ((contentPostItem.component.indexOf('maincontent') > -1) || (contentPostItem.component.indexOf('maincontent') === -1))"
                  class="item-settings-button"
                  @click="
                    confirmRemoveFrame(
                      0,
                      contentPostItem.frameId,
                      'page',
                      contentPostItem.frameDataId
                    )
                  "
                >
                  <i class="fal fa-trash-alt"></i>
                </button>
              </div>

              <!-- CARD BODY -->
              <div class="card-editor position-relative"
                :style="{
                  'background-color': contentPostItem.component.includes('maincontent') ? getColorBackgroundSection(index, contentPostItem.extra.background_color) : '',
                }"
              >
                <!-- CARD BACKGROUND IMAGE -->
                <base-image
                  v-if="contentPostItem.backgroundImage != null"
                  :source="contentPostItem.backgroundImage.uri"
                  custom-class="position-absolute ps-0 w-100 h-100 img-fluid"
                  :style="
                    {
                      'z-index': '0',
                      'object-position': validadeFocalPoint(contentPostItem.extra.background_image_focal_point),
                      'opacity': `${contentPostItem.extra.background_image_opacity ? contentPostItem.extra.background_image_opacity : 80}%`,
                      'object-fit': 'cover'
                    }
                  "
                />

                <!-- CONTAINET DRAGGBLE FRAMES (APENAS MAINCONTENT) -->
                <draggable
                  tag="div"
                  :id="`FrameSort-${contentPostItem.frameId}`"
                  :list="contentPost[index].frameContent"
                  handle=".draggable"
                  group="frame"
                  @start="onStartMoveFrame"
                  @end="onEndMoveFrame"
                  class="row justify-content-center"
                  v-if="!importMode && contentPostItem.component.includes('maincontent-')"
                >
                  <!-- FRAMES -->
                  <div
                    v-for="(postItem, postItemIndex) in selectPostItem(contentPostItem)"
                    :key="postItem.frameId"
                    tabindex="0"
                    :id="postItem.frameId"
                    :class="['my-3 post-item ', selectGrid(postItem), postItem.frameType == 'container' && postItem.extra && `d-flex align-items-${postItem.extra.vertical_align}`, postItem.frameType == 'gallery' && 'position-relative']"
                    :type="postItem.frameType"
                    :style="getFrameStyle(postItem)"

                  >
                    <!-- FRAME BACKGROUND IMAGE -->
                    <base-image
                      v-if="postItem.frameType == 'container' && postItem.extra != null && postItem.extra.background_image != null"
                      :source="postItem.extra.background_image.uri"
                      custom-class="position-absolute ps-0 w-100 h-100 img-fluid"
                      :style="{
                        'z-index': '0',
                        'object-position': validadeFocalPoint(postItem.extra.background_image_focal_point),
                        'opacity': `${postItem.extra.background_image_opacity ? postItem.extra.background_image_opacity : 80}%`,
                        'object-fit': 'cover'
                      }"
                    />
                    <!-- BUTTON ADD FRAME (RIGHT) -->
                    <!--
                    <add-frame
                      v-if="validateShowAddFrame(selectPostItem(contentPostItem), index)"
                      ref="postbar"
                      referer="frame"
                      action="right"
                      :frame="postItem.frameId"
                      type="right"
                      @return-slot="setPostBarSlot"
                      :slotNum="index"
                      :frameButtons="frameButtons"
                    />
                    -->
                    <!-- FRAME HEADER -->
                    <template
                      v-if="!['home', 'newsletter', 'contact'].includes(postItem.component)">
                      <div class="text-right item-settings" :test="postItem.component">
                        <span
                          v-b-tooltip.hover
                          title="Arraste para reordenar"
                          class="item-settings-button draggable"
                        >
                          <i class="fal fa-arrows"></i>
                        </span>

                        <template>
                          <span
                            v-b-tooltip.hover
                            title="Configurações"
                            class="item-settings-button"
                            v-if="!(postItem.frameType == 'title' && postItemIndex == 0)"
                            @click="
                              openSettings(
                                postItem,
                                postItemIndex,
                                contentPostItem.frameId
                              )
                            "
                          >
                            <i class="fal fa-cog"></i>
                          </span>
                        </template>

                        <template v-if="postItem.frameType == 'comments'">
                          <span
                            v-b-tooltip.hover
                            title="Solicitar depoimento"
                            class="item-settings-button"
                            @click="externalTestimonyRequest(postItem.frameId)"
                          >
                            <i class="fal fa-share-square"></i>
                          </span>
                        </template>

                        <template v-if="postItem.frameType == 'script'">
                          <span
                            class="item-settings-button"
                            @click="toggleRunScript(postItem, postItemIndex)"
                          >
                            <i
                              v-b-tooltip.hover
                              title="Executar script"
                              class="fal fa-play"
                              v-if="postItem.runCode == false"
                            ></i>
                            <i
                              v-b-tooltip.hover
                              title="Editar script"
                              class="fal fa-code"
                              v-else
                            ></i>
                          </span>
                        </template>

                        <template v-if="!['home', 'newsletter', 'contact'].includes(postItem.component)">
                          <span
                            v-if="postItem.grid !== 99 && !(postItem.frameType == 'title' && postItemIndex == 0)"
                            v-b-tooltip.hover
                            title="Alterar largura"
                            class="item-settings-button"
                            @click="changeGrid(postItem, postItemIndex, contentPostItem)"
                          >
                            <i class="fal fa-columns"></i>
                          </span>

                          <span
                            v-b-tooltip.hover
                            title="Duplicar"
                            v-if="postItem.component == 'maincontent'"
                            class="item-settings-button"
                            @click="
                              confirmCloneFrame(
                                postItem,
                                postItem.frameType,
                                postItem.frameContent,
                                contentPostItem.frameId,
                                postItemIndex,
                                postItem
                                )">
                            <i class="fal fa-clone"></i>
                          </span>

                          <span
                            v-b-tooltip.hover
                            title="Remover"
                            class="item-settings-button"
                            @click="
                              confirmRemoveFrame(
                                postItemIndex,
                                contentPostItem.frameId,
                                'frame',
                                contentPostItem.frameDataId
                              )
                            "
                            v-if="postItem.component == 'maincontent'"
                          >
                            <i class="fal fa-trash-alt"></i>
                          </span>
                        </template>

                        <template v-if="$route.query.mode == '3P1C5'">
                          <span
                            v-b-tooltip.hover
                            title="Copiar configurações do frame"
                            class="item-settings-button"
                            @click="
                              handleCopySettingsFrame(postItem)
                            "
                          >
                            <i class="fal fa-copy"></i>
                          </span>
                        </template>
                      </div>
                    </template>

                    <!-- FRAME LIST -->
                    <template v-if="postItem.frameType === 'subpages'">
                      <FrameList />
                    </template>

                    <!-- FRAME CONTAINER -->
                    <template v-else>
                      <div :class="[postItem.frameType === 'container' && `my-5 w-100`]">
                        <FrameContainer
                          :showSettingsChilds="postItem.component === 'maincontent' && postItem.frameType === 'container'"
                          :postType="postType"
                          :postId="parseInt(postId)"
                          :item="postItem"
                          :index="postItemIndex"
                          :sectionIndex="isHome ? index + 1 : index"
                          :siteId="siteId"
                          :sketch="totalPost.sketch"
                          @openMediaManager="
                            openMediaManager(
                              postItemIndex,
                              contentPostItem.frameId,
                              contentPostItem.frameContent[postItemIndex].frameContent
                            )
                          "
                          @deleteContainer="savePost(1)"
                          @changeTextToVideo="
                            changeTextToVideo($event, postItem, postItemIndex)
                          "
                          @changeTextToMusic="
                            changeTextToMusic($event, postItem, postItemIndex)
                          "
                          @changeImageFromGallery="
                            changeImageFromGallery($event, contentPostItem.frameId, postItem, postItemIndex)
                          "
                          @deleteFrameChild="
                            deleteFrameChild($event, postItem, postItemIndex, contentPostItem.frameId)
                          "
                          @openSettingsFrameChild="
                            openSettingsFrameChild(
                              $event,
                              postItem,
                              postItemIndex,
                              contentPostItem.frameId
                            )
                          "
                        />
                      </div>

                      <add-last-frame
                        v-if="postItem.frameType === 'container'"
                        extraClass="add-last-frame--frame-container"
                        :frameButtons="frameButtonsContainer"
                        :slotNum="index"
                        :showButtonPreset="false"
                        :extraStyle="{ bottom: '10px' }"
                        @return-slot="setIndexSection"
                        @click-add-last-frame="($event) => clickAddLastFrameContainer($event, postItemIndex)"
                      />
                    </template>
                  </div>

                    <!--
                    <StoreCategories
                      v-if="isStore(contentPostItem.component)"
                      :postOptions="contentPostItem.options"
                      @options="contentPostItem.options = { store_categories: $event }"
                    />
                    -->
                </draggable>

                <!-- CONTAINER NO DRAGGBLE (SEÇÃO QUE NAO FOR MAINCONTENT) -->
                <div
                  class="row justify-content-center"
                  v-else-if="!importMode"
                >
                    <!-- FRAMES -->
                    <div
                      class="my-3 post-item"
                      tabindex="0"
                      v-for="(postItem, postItemIndex) in selectPostItem(contentPostItem)"
                      :key="postItem.frameId"
                      :id="postItem.frameId"
                      :class="[selectGrid(postItem), postItem.frameType == 'gallery' && 'position-relative']"
                      :type="postItem.frameType"
                      :style="getFrameStyle(postItem)"
                    >
                      <!-- FRAME BACKGROUND IMAGE -->
                      <base-image
                        v-if="postItem.extra != null && postItem.extra.background_image != null"
                        :source="postItem.extra.background_image.uri"
                        custom-class="position-absolute ps-0 w-100 h-100 img-fluid"
                        :style="{
                          'z-index': '0',
                          'object-position': validadeFocalPoint(postItem.extra.background_image_focal_point),
                          'opacity': `${postItem.extra.background_image_opacity ? postItem.extra.background_image_opacity : 80}%`,
                          'object-fit': 'cover'
                        }"
                      />

                      <!-- FRAME HEADER -->
                      <template
                        v-if="postItem.frameType != 'title' && !['home', 'newsletter', 'contact'].includes(postItem.component)">
                        <div class="text-right item-settings" :test="postItem.component">
                          <template>
                            <span
                              v-b-tooltip.hover
                              title="Configurações"
                              class="item-settings-button"
                              @click="
                                openModalSettings(
                                  postItem,
                                  postItemIndex,
                                  contentPostItem.frameId
                                )
                              "
                            >
                              <i class="fal fa-cog"></i>
                            </span>
                          </template>
                          <template v-if="postItem.frameType == 'comments'">
                            <span
                              v-b-tooltip.hover
                              title="Solicitar depoimento"
                              class="item-settings-button"
                              @click="externalTestimonyRequest(postItem.frameId)"
                            >
                              <i class="fal fa-share-square"></i>
                            </span>
                          </template>
                          <template v-if="postItem.frameType == 'script'">
                            <span
                              class="item-settings-button"
                              @click="toggleRunScript(postItem, postItemIndex)"
                            >
                              <i
                                v-b-tooltip.hover
                                title="Executar script"
                                class="fal fa-play"
                                v-if="postItem.runCode == false"
                              ></i>
                              <i
                                v-b-tooltip.hover
                                title="Editar script"
                                class="fal fa-code"
                                v-else
                              ></i>
                            </span>
                          </template>
                          <template v-if="!['home', 'newsletter', 'contact'].includes(postItem.component)">
                            <span
                              v-b-tooltip.hover
                              title="Alterar largura"
                              class="item-settings-button"
                              @click="changeGrid(postItem, postItemIndex, contentPostItem)"
                            >
                              <i class="fal fa-columns"></i>
                            </span>

                            <span
                              v-b-tooltip.hover
                              title="Duplicar"
                              v-if="postItem.component == 'maincontent'"
                              class="item-settings-button"
                              @click="
                                confirmCloneFrame(
                                  postItem,
                                  postItem.frameType,
                                  postItem.frameContent,
                                  contentPostItem.frameId,
                                  postItemIndex,
                                  postItem
                                  )">
                              <i class="fal fa-clone"></i>
                            </span>


                            <span
                              v-b-tooltip.hover
                              title="Remover"
                              class="item-settings-button"
                              @click="
                                confirmRemoveFrame(postItemIndex, contentPostItem.frameId, 'frame' ,contentPostItem.frameDataId)
                              "
                              v-if="postItem.component == 'maincontent'"
                            >
                              <i class="fal fa-trash-alt"></i>
                            </span>
                          </template>
                        </div>
                      </template>

                      <!-- FRAME LIST -->
                      <template v-if="postItem.frameType === 'subpages'">
                        <FrameList />
                      </template>

                      <!-- FRAME CONTAINER -->
                      <template v-else>
                        <FrameContainer
                          :showSettingsChilds="postItem.component === 'maincontent'"
                          :postType="postType"
                          :postId="parseInt(postId)"
                          :item="postItem"
                          :index="postItemIndex"
                          :siteId="siteId"
                          :sketch="totalPost.sketch"
                          :defaultColorsActive="false"
                          @openMediaManager="
                            openMediaManager(
                              postItemIndex,
                              contentPostItem.frameId,
                              contentPostItem.frameContent[postItemIndex].frameContent
                            )
                          "
                          @deleteContainer="savePost(1)"
                          @changeTextToVideo="
                            changeTextToVideo($event, postItem, postItemIndex)
                          "
                          @changeTextToMusic="
                            changeTextToMusic($event, postItem, postItemIndex)
                          "
                          @changeImageFromGallery="
                            changeImageFromGallery($event, contentPostItem.frameId, postItem, postItemIndex)
                          "
                        />
                      </template>
                    </div>

                    <StoreCategories
                      v-if="isStore(contentPostItem.component)"
                      :postOptions="contentPostItem.options"
                      @options="contentPostItem.options = { store_categories: $event }"
                    />
                </div>

                <!-- IMPORTA CONTEUDO DO INSTAGRAM -->
                <transition name="slide-down-fade">
                  <div class="import-content z-n1" v-if="importMode">
                    <div class="container-fluid">
                      <div class="row justify-content-between py-3">
                        <div class="col-auto pointer" @click="importMode = false">
                          <i class="fal fa-chevron-down"></i>
                        </div>
                      </div>
                      <div class="row justify-content-center">
                        <keep-alive>
                          <SocialMediaPostRecovery
                            @importSocialMediaContent="importSocialMediaContent"
                          />
                        </keep-alive>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>

              <!-- BUTTON ADD LAST FRAME -->
              <add-last-frame
                :extraStyle="{ bottom: '75px' }"
                v-if="!importMode && contentPostItem.component.includes('maincontent-')"
                :frameButtons="frameButtonsLastFrame"
                :slotNum="index"
                :remainOpen="true"
                @return-slot="setIndexSection"
                @click-add-last-frame="($event) => clickAddLastFrame($event)"
                @add-frame="addLastPresetFrame"
              />
            </div>

            <!-- BUTTON ADD SECTION -->
            <add-section
              :slotNum="index"
              @return-slot="setIndexSection"
              @create-section="createSection"
            />
          </div>
        </div>

        <b-modal
          id="modalVideo"
          ref="modalVideo"
          centered
          modal-class="full-white"
          title="Adicionar vídeo"
          ok-title="Enviar"
          cancel-title="Cancelar"
          hide-footer
          @close="verifyEmptyCard"
        >
          <div class="row">
            <div class="col-12">
              <p>
                <strong>Copie e cole o link do vídeo na área abaixo</strong>
              </p>
              <input
                type="url"
                ref="urlVideo"
                placeholder="Link do vídeo"
                class="form-control"
              />
            </div>
            <div class="col-12 text-right mt-3">
              <button @click="createFrameVideo()" class="btn btn-primario py-2">
                Enviar
              </button>
            </div>
          </div>
        </b-modal>

        <b-modal
          id="modalTestimony"
          ref="modalTestimony"
          centered
          modal-class="full-white"
          size="xl"
          title="Copie o link e solicite um novo depoimento."
          ok-title="OK"
          cancel-title="Cancelar"
          hide-footer
        >
          <div class="row">
            <div class="col-12">
              <input
                id="linkTestimony"
                class="form-control mb-3"
                :value="testimonyLink"
              />
              <button class="btn btn-primario py-2" @click="copyLink">
                Copiar link
              </button>
            </div>
            <div class="col-12 text-right mt-3">
              <button
                @click="$bvModal.hide('modalTestimony')"
                class="btn btn-primario py-2"
              >
                OK
              </button>
            </div>
          </div>
        </b-modal>

        <ModalSettingsFrame
          @transformInGallery="transformInGallery"
          :activeItem="activeSettingsItem"
          :settingsItemModal="settingsItemModal"
          @onClose="settingsItemModal = false"
          :itemIndex="activeSettingsItemIndex"
          :pageFrameIndex="pageFrameIndex"
          @activeSettings="activeSettingsItem = $event"
        />

        <ModalSettingsPageFrame
          :activeItem="activeSettingsPageFrame"
          :settingsPageFrameModal="settingsPageFrameModal"
          @onClose="settingsPageFrameModal = false"
        />
      </div>
    </template>

    <div
      class="total-post-settings"
      v-show="step === 2"
      :key="2"
    >
      <div class="container-editor">
        <PostEditorSettings
          ref="posteditorset"
          @saving="saving = $event"
          :postId="postId"
          :deletedFrames="deletedFrames"
          :postType="postType"
          :step="step"
        />
      </div>
    </div>
    <div v-if="this.$data.fileProgressShow">
      <FileProgress
        :percentage="this.$data.uploadPercentage"
        :filesTotal="this.$data.filesTotal"
        :currentfile="this.$data.currentfile"
      />
    </div>
    <CardInPost
      :newCardIndex="postBarSlotIndex + 1"
      :postId="postId"
      v-if="modalCard"
      @cancel="modalCard = $event"
      @request="requestNewFrame('page', $event)"
    ></CardInPost>
  </div>
</template>

<script>
import MediaManager from "@/components/organisms/MediaManager"
import CardInPost from "@/components/organisms/CardInPost";
import FileProgress from "@/components/organisms/FileProgress";
import FrameContainer from "@/components/blocks/FrameContainer";
import FrameList from "@/components/blocks/FrameList";
import Loading from "@/components/Loading.vue";
import ModalSettingsFrame from "@/components/organisms/ModalSettingsFrame";
import ModalSettingsPageFrame from "@/components/organisms/ModalSettingsPageFrame";
import PostEditorSettings from "@/components/organisms/PostEditorSettings";
import SocialMediaPostRecovery from "@/components/molecules/SocialMediaPostRecovery";
import StoreCategories from "@/components/blocks/StoreCategories.vue";
import AddPostBar from "@/components/molecules/AddPostBar.vue";
import AddPostBarFixed from "@/components/molecules/AddPostBarFixed.vue";
import PreviewModal from "@/components/molecules/PreviewModal.vue";
import OpenDesignBtn from "@/components/atoms/OpenDesignBtn.vue";

import apiMixins from "@/mixins/apiMixins";
import instagramMixins from "@/mixins/instagramMixins";
import youtubeMixins from "@/mixins/youtubeMixins";
import vimeoMixins from "@/mixins/vimeoMixins";
import uploadFiles from "@/mixins/uploadFiles";
import sectionsMixins from "@/mixins/sectionsMixins";
import postMixins from "@/mixins/postMixins";

import { mapGetters, mapState } from "vuex";
import BaseImage from '../atoms/BaseImage.vue';
import AddFrame from '../molecules/AddFrame.vue';
import AddSection from '../molecules/AddSection.vue';
import draggable from "vuedraggable";
import AddLastFrame from '../molecules/AddLastFrame.vue';
import SidebarSettings from '../organisms/SidebarSettings.vue';

export default {
  data() {
    return {
      isPresetFrame: false,
      maxItemSelected: 200,
      configsReference: null,
      openSidebarSettings: false,
      isLastNewFrame: false,
      isChangePicture: false,
      pictureForChange: null,
      postBarSlotIndex: 0, // slot do postbar clicado
      savingLoading: false, // Texto exibido durando o auto save
      verificationChanges: null, // Aplica a função setInterval ( sendo uma variavel pode chamar a clearSetInterval )
      newVal: -1, // Atualizado sempre que o contentPost atualiza
      oldVal: 0, // Atualizado sempre que fizer o auto save (oldVal = newVal)
      saving: false, // Valor que vem do PostEditorSettings ( true se terminou o SaveSketch)
      openSaveSketch: false, // True abre o PosEditorSettings
      showMediaManager: false, // True abre o MediaManager
      galleryRequestedMediaManager: null, // index da galeria que faz request para o MediaManager
      sortMode: false, // True abre o modal para reordernar os frame
      importMode: false, // True abre modal para importar instagram
      activeSettingsItem: {}, // dados do frame atual
      activeSettingsPageFrame: {}, // dados do Page Frame atual
      activeSettingsItemIndex: null, // index do frame atual
      activeSettingsItemChildIndex: null, // id do frame atual
      settingsItemModal: false, // modal de editar as config do frame
      settingsPageFrameModal: false, // modal de editar as config do Page Frame
      deletedFrames: [], // frames que foram deletados
      importedMedias: [],
      files: "",
      boxOne: "",
      boxTwo: "",
      step: 1, // passo que esta o PostEditor (1 = ediçao, 2 = postEditorSettings, 3 = salva e fecha)
      postType: "", // verifica qual o tipo do post
      isBlankPost: false, // verifica se o post esta sem conteudo
      loadingVideo: false, // True mostra a tela de loading
      loadingImage: false,
      nextStepText: false, // Texto do botão de avançar step
      newGallery: false,
      Openframe: false,
      modalCard: false,
      pageFrameId: null, // id do card dentro da pagina
      pageFrameIndex: null, // index do card dentro da pagina
      listIndexMainContent: [],
      frameButtonsIndex: null,
      testimonyLink: "",
      frameDataId: null,
      frameContent:null,
      frameButtons: [
        {
          icon: "fal fa-text",
          title: "Texto",
          tooltip: "Criar texto",
          request: () => {
            this.requestNewFrame("text");
          },
          clickEvent: (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: "fal fa-photo-video",
          title: "Fotos e Vídeos",
          tooltip: "Fotos e Vídeos",
          request: () => {
            this.loadingImage = true;
            const index = this.contentPost[this.pageFrameIndex].frameContent.length - 1;
            this.frameContent =  this.contentPost[this.pageFrameIndex].frameContent
            this.frameDataId = this.contentPost[this.pageFrameIndex].frameDataId

            this.newGallery = true;

            this.openMediaManager(
              index,
              this.contentPost[this.pageFrameIndex].frameId
            );
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          title: "Criar cards",
          icon: "fal fa-browser",
          tooltip: "Criar cards",
          clickEvent: () => {
            this.saveSketchEditor()
            this.requestCardPost("post")
          },
        },
        {
          icon: "fab fa-instagram",
          title: "Instagram",
          tooltip: "Importar posts do instagram",
          request: async () => {
            await this.saveSketchEditor();
            this.importMode = true;
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: "fal fa-hand-point-up",
          title: "Botão",
          tooltip: "Criar botão",
          request: async () => {
            const content = {
              dataPhone: {
                idd: "55",
                phone: "",
              },
              settings: {
                target: "_blank",
                type: "url",
                size: "normal",
                class: "",
              },
              ref: "https://",
              title: "",
              text: "Clique aqui",
            };
            let newFrame = await this.requestNewFrame("button", content)
            const indexFrame = this.contentPost[this.postBarSlotIndex].frameContent.length - 1

            this.openSettings(
              this.contentPost[this.postBarSlotIndex].frameContent[indexFrame],
              indexFrame,
              newFrame.frameId
            )
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: null,
          title: "Antes/Depois",
          img: "../../assets/img/icons/before-after.svg",
          tooltip: "Criar imagem antes e depois",
          request: () => {
            const content = {
              beforePicture:
                "https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-1.jpg",
              afterPicture:
                "https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-2.jpg",
            };
            this.requestNewFrame("beforeAfterImage", content);
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: "fal fa-code",
          title: "Criar script",
          tooltip: "Criar script",
          request: () => {
            this.requestNewFrame("script");
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        // {
        //   icon: "far fa-comment",
        //   request: () => {
        //     this.requestNewFrame("comments");
        //   },
        //   clickEvent: async (i) => {
        //     this.newFrameEvent(i)
        //   },
        // },
        {
          icon: "fal fa-paper-plane",
          title: "Formulário",
          tooltip: "Criar formulário",
          request: () => {
            const data = {
              content: [],
              message: "",
              name: "",
              submit: "",
            };
            this.requestNewFrame("form", data);
          },
          clickEvent: async (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: "fal fa-clipboard-check",
          title: "Faq",
          tooltip: "Criar Faq",
          request: () => {
            const data = {
              content: [],
            };
            this.requestNewFrame("faq", data);
          },
          clickEvent: (i) => {
            this.newFrameEvent(i);
          },
        },
        {
          icon: "fal fa-list-alt",
          tooltip: "Criar item de plano",
          title: "Planos",
          request: () => {
            const data = {
              content: [],
              items: [],
              items_per_line: 4
            };
            this.requestNewFrame("card_list", data);
          },
          clickEvent: (i) => {
            this.newFrameEvent(i);
          },
        },
      ],
      frameButtonsContainer: [
        {
          icon: "fal fa-heading",
          title: "Título",
          tooltip: "Adicionar título",
          request: async (indexParent) => {
            await this.requestLastNewFrame(
              "title",
              "",
              12,
              12,
              null,
              null,
              indexParent
            );
          },
        },
        {
          icon: "fal fa-text",
          title: "Texto",
          tooltip: "Adicionar texto",
          request: async (indexParent) => {
            await this.requestLastNewFrame(
              "text",
              "",
              12,
              12,
              null,
              null,
              indexParent
            );
          },
        },
        {
          icon: "fal fa-photo-video",
          title: "Mídia",
          tooltip: "Adicionar mídia",
          request: (indexParent) => {
            this.maxItemSelected = 2;

            this.loadingImage = true;

            const index = this.contentPost[this.pageFrameIndex].frameContent[indexParent].frameContent.length;
            const frameId = this.contentPost[this.pageFrameIndex].frameContent[indexParent].frameId;
            this.frameContent =  this.contentPost[this.pageFrameIndex].frameContent[indexParent];
            this.frameDataId = frameId;
            this.activeSettingsItemIndex = indexParent;

            this.newGallery = true;
            this.isLastNewFrame = true;

            this.openMediaManager(
              index,
              frameId
            );
          },
        },
        {
          icon: "fal fa-hand-point-up",
          title: "Botão",
          tooltip: "Adicionar botão",
          request: async (indexParent) => {
            const content = {
              dataPhone: {
                idd: "55",
                phone: "",
              },
              settings: {
                target: "_blank",
                type: "url",
                size: "normal",
                class: "",
              },
              ref: "https://",
              title: "",
              text: "Clique aqui",
            };

            await this.requestLastNewFrame(
              "button",
              content,
              12,
              12,
              null,
              null,
              indexParent
            );
          },
        },
      ],
      frameButtonsLastFrame: [
        {
          icon: "fal fa-heading",
          title: "Título",
          tooltip: "Adicionar título",
          request: async () => {
            this.activeSettingsItemIndex = null;

            await this.requestLastNewFrame(
              "title",
              "",
              12,
              12,
              null,
              null
            );
          },
        },
        {
          icon: "fal fa-text",
          title: "Texto",
          tooltip: "Adicionar texto",
          request: () => {
            this.requestLastNewFrame(
              "text",
              "",
              12,
              12,
              null,
              null
            );
          },
        },
        {
          icon: "fal fa-photo-video",
          title: "Mídia",
          tooltip: "Adicionar mídia",
          request: () => {
            this.loadingImage = true;
            let index = this.contentPost[this.pageFrameIndex].frameContent.length;
            let frameId = this.contentPost[this.pageFrameIndex].frameId;
            this.frameContent =  this.contentPost[this.pageFrameIndex].frameContent
            this.frameDataId = this.contentPost[this.pageFrameIndex].frameDataId

            this.newGallery = true;
            this.isLastNewFrame = true;

            this.openMediaManager(
              index,
              frameId
            );
          },
        },
        {
          icon: "fab fa-instagram",
          title: "Instagram",
          tooltip: "Importar posts do instagram",
          request: async () => {
            this.isLastNewFrame = true;

            await this.saveSketchEditor();

            this.importMode = true;
          },
        },
        {
          icon: null,
          title: "Antes/Depois",
          img: "../../assets/img/icons/before-after.svg",
          tooltip: "Criar imagem antes e depois",
          request: () => {
            const content = {
              beforePicture:
                "https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-1.jpg",
              afterPicture:
                "https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-2.jpg",
            };
            this.requestLastNewFrame("beforeAfterImage", content);
          },
        },
        {
          icon: "fal fa-code",
          title: "Script",
          tooltip: "Adicionar script",
          request: () => {
            this.requestLastNewFrame(
              "script",
              "",
              12,
              12,
              null,
              null,
            );
          },
        },
        {
          icon: "fal fa-clipboard-check",
          title: "Faq",
          tooltip: "Criar Faq",
          request: () => {
            const data = {
              content: [],
            };

            this.requestLastNewFrame(
              "faq",
              data,
              12,
              12,
              null,
              null
            );
          },
        },
        {
          icon: "fal fa-paper-plane",
          title: "Formulário",
          tooltip: "Adicionar formulário",
          request: () => {
            const data = {
              content: [],
              message: "",
              name: "",
              submit: "",
            };

            this.requestLastNewFrame(
              "form",
              data,
              12,
              12,
              null,
              null
            );
          }
        },
        {
          icon: "fal fa-hand-point-up",
          title: "Botão",
          tooltip: "Adicionar botão",
          request: async () => {
            const content = {
              dataPhone: {
                idd: "55",
                phone: "",
              },
              settings: {
                target: "_blank",
                type: "url",
                size: "normal",
                class: "",
              },
              ref: "https://",
              title: "",
              text: "Clique aqui",
            };
            let newFrame = await this.requestLastNewFrame("button", content)
            const indexFrame = this.contentPost[this.postBarSlotIndex].frameContent.length - 1

            this.openSettings(
              this.contentPost[this.postBarSlotIndex].frameContent[indexFrame],
              indexFrame,
              newFrame.frameId
            )
          },
        },
      ],
    };
  },
  props: {
    postId: {
      required: true,
      default: 0,
    },
  },
  mixins: [sectionsMixins, apiMixins, uploadFiles, instagramMixins, youtubeMixins, vimeoMixins, postMixins],
  components: {
    CardInPost,
    FileProgress,
    FrameContainer,
    FrameList,
    MediaManager,
    ModalSettingsFrame,
    ModalSettingsPageFrame,
    Loading,
    PostEditorSettings,
    SocialMediaPostRecovery,
    StoreCategories,
    AddPostBar,
    AddPostBarFixed,
    PreviewModal,
    OpenDesignBtn,
    MediaManager,
    BaseImage,
    AddFrame,
    AddLastFrame,
    AddSection,
    draggable,
    SidebarSettings,
},
  computed: {
    ...mapState("dashboardModule", {
      totalPost: (state) => state.activePost,
      contentPost: (state) => state.activePost.content,
      published: (state) => state.activePost.dates,
      updatePostEditorStatus:(state) => state.updatePostEditorStatus
    }),
    ...mapGetters("dashboardModule", [
      "selectedMedias",
      "loadingStatus",
      "getSiteLink",
      "getInDraggable",
      "getLayoutStyles",
    ]),
    postIsPublished() {
        if (typeof(this.published) !== 'undefined') {
            if (this.published.published_at && this.published.published_at !== null) {
                return true;
            }
            return false;
        } else {
            setTimeout(() => this.postIsPublished, 500);
        }
    },
    isHome() {
      return this.postType === "home";
    },
  },
//   mounted(){
//     var widthPage = window.innerWidth;
//       if(widthPage < 998) {
//         this.$zendesk.hide()
//       }
//   },
  watch: {
    showMediaManager() {
      if (!this.showMediaManager) {
        this.loadingImage = false;
      }
    },
    published() {
      if (this.published.published_at || this.postType != "post") {
        this.nextStepText = "Salvar";
      } else {
        this.nextStepText = "Continuar";
      }
    },
    importMode() {
      if (!this.importMode) {
        this.$store.dispatch("dashboardModule/resetAllSaveMedia");
      }
    },
    contentPost: {
      handler: function (val, oldVal) {
        this.newVal += 1;
      },
      deep: true,
    },
    saving() {
      if (this.saving) {
        this.savingLoading = "Salvando rascunho...";
      } else {
        this.savingLoading = "Rascunho salvo";
        setTimeout(() => {
          this.savingLoading = false;
        }, 3000);
        if (this.step == 1) {
          this.openSaveSketch = false;
        }
      }
    },
  },
  methods: {
    handleCopySettingsFrame(frame) {
      const copyToClipboard = async (string) => {
        await navigator.clipboard.writeText(string);
      };

      let frames = [];
      let frameFormated = {
        id: 1,
        position: 0,
        type: frame.frameType,
        grid: frame.grid,
        gridMobile: frame.gridMobile,
        component: "maincontent-default",
        extra: frame.extra,
      };
      let frameFormatedString = '';

      if (frame.frameType === 'container') {
        frame.frameContent.forEach((frame, key) => {
          frames.push({
            id: key + 1,
            position: key,
            type: frame.frameType,
            content: frame.frameContent,
            grid: frame.grid,
            gridMobile: frame.gridMobile,
            component: "maincontent-default",
            extra: frame.extra,
          });
        });

        frameFormated.frames = frames;
      } else {
        frameFormated.content = frame.frameContent;
      }

      frameFormatedString = JSON.stringify(frameFormated);

      try {
        copyToClipboard(frameFormatedString);

        this.$bvToast.toast('Frame copiado para a área de transferência.', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Falha ao copiar frame: ', error);

        this.$bvToast.toast('Falha ao copiar frame, tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        });
      }
    },
    getColorBackgroundSection(position, extraColor = null) {
      if (extraColor) {
        return extraColor;
      }

      if ((this.isHome && position === 0)) {
        return null
      }

      if (this.isHome && position > 0) {
        position = position + 1;
      }

      let backgroundColorDefault = '';

      const backgroundColorObject = this.layoutStyles.find(color => color.id === "backgroundSecondaryColor");

      if (backgroundColorObject) {
        backgroundColorDefault = backgroundColorObject.value;
      }

      // VERIFICA SE A SEÇÃO É UMA SEÇÃO PRIMARIA OU SECUNDARIA
      // COM BASE NISSO DEFINE A COR DE CADA UMA
      if (this.isPrimarySection(position)) {
        const backgroundColorObject = this.layoutStyles.find(color => color.id === "backgroundColor");

        if (backgroundColorObject) {
          backgroundColorDefault = backgroundColorObject.value;
        }
      }

      return backgroundColorDefault;
    },
    isPrimarySection(position) {
      return position % 2 === 0;
    },
    isSecundarySection(position) {
      return position % 2 !== 0;
    },
    scrollUp() {
      console.log('scrollUp');
    },
    scrollDown() {
      console.log('scrollDown');
    },
    onStartMoveFrame() {
      this.$store.dispatch('dashboardModule/UPDATE_IN_DRAGGABLE', true);
    },
    onEndMoveFrame() {
      this.$store.dispatch('dashboardModule/UPDATE_IN_DRAGGABLE', false);
    },
    getFrameStyle(frame) {
      let style = {}

      if (frame.frameType != 'text') {
        style['backgroundColor'] = frame.extra != null && frame.extra.background_color != null
          ? frame.extra.background_color
          : 'transparent'
      }

      style['padding'] = frame.extra != null && frame.grid == 99
        ? '1.5rem 0'
        : '1.5rem'

      return style;
    },
    updateItemActive(item) {
      this.activeSettingsItem = JSON.parse(JSON.stringify(item));
    },
    validateShowAddFrame(items, index) {
      if (index === items.length - 1) {
        // Último elemento, não exibe o botão
        return false;
      }

      const currentGrid = items[index].grid;
      const nextGrid = items[index + 1].grid;

      if (currentGrid === 12) {
        // Coluna col-12, nao possui botão
        return false;
      } else if (currentGrid === 6 && nextGrid === 6) {
        // Colunas col-6, verificação baseada em index/2
        const currentRow = Math.floor(index / 2);
        const nextRow = Math.floor((index + 1) / 2);

        return currentRow === nextRow;
      } else if (currentGrid === 4 && nextGrid === 4) {
        // Colunas col-4, verificação baseada em index/3
        const currentRow = Math.floor(index / 3);
        const nextRow = Math.floor((index + 1) / 3);

        return currentRow === nextRow;
      } else {
        // Outras combinações de colunas, exibe o botão
        return true;
      }
    },
    handlePositionChangeSection(item, index, newPosition) {
      // REMOVE O ELEMENTO DA POSIÇÃO ANTIGA
      this.contentPost.splice(index, 1);

      // VALIDA SE A SEÇÃO VAI SUBIR OU DESCER
      index -= newPosition == 'up' && 1
      index += newPosition == 'down' && 1

      // ADICIONA O ELEMENTO NA NOVA POSIÇÃO
      this.contentPost.splice(index, 0, item);
    },
    validadeSettingsExtra(item) {
        let backgroundImage;
        const extraColor = !!item.extra.background_color;

        if (item.backgroundImage) {
          if (item.backgroundImage.uri) {
            backgroundImage = true;
          } else {
            backgroundImage = false;
          }
        } else {
          backgroundImage = false;
        }

        return extraColor || backgroundImage;
    },
    validadeFocalPoint(objectPosition) {
      if (!objectPosition) {
        return '50% 50%';
      }

      const x = objectPosition.x !== null && objectPosition.x !== undefined ? objectPosition.x : 50;
      const y = objectPosition.y !== null && objectPosition.y !== undefined ? objectPosition.y : 50;

      return `${x}% ${y}%`;
    },
    sortingRules(index, type) {
      // BLOQUEIA SUBIR SEÇÃO CASO SEJA A SEGUNDA
      if (index == 1 && type == 'up') {
        return true
      }

      // BLOQUEIA DESCER SEÇÃO CASO SEJA A ULTIMA
      if (this.contentPost.length == index + 1 && type == 'down') {
        return true
      }

      // Permite ordenar caso não seja o primeiro card e tenham mais de 2 cards na página
      if (index != 0 && this.contentPost.length > 2) {
        return false;
      }

      return true;
    },
    // abre o modal de preview caso auto save tenha terminado
    waitAutoSaveToPreview() {
        if (!this.saving) {
            this.$bvModal.show('preview-modal');
        } else {
            setTimeout(() => this.waitAutoSaveToPreview() , 500)
        }
    },
    // salva rascunho e tenta abrir a modal de preview
    openPreview() {
        this.saveSketchEditor();
        this.waitAutoSaveToPreview();
    },
    closeTabs() {
      this.showMediaManager = false;
    },
    /* Verifica se o card ta vazio */
    verifyEmptyCard(){
     if(this.frameContent.length === 0) {
       this.removePageFrame(this.pageFrameIndex, this.frameDataId);
     }
    },
    clickAddLastFrameContainer(index, parentIndex) {
      this.activeSettingsItemIndex = null;

      this.frameButtonsContainer[index].request(parentIndex);
    },
    clickAddLastFrame(index) {
      this.activeSettingsItemIndex = null;

      this.frameButtonsLastFrame[index].request();
    },
    async addLastPresetFrame(preset) {
      this.isLastNewFrame = true;

      await this.generateFrames(preset);

      this.isLastNewFrame = false;
    },
    // CRIA UMA NOVA SEÇÃO (CARD)
    async createSection(newSection) {
      // TODO: O NEWSECTION VEM COM INFORMAÇÃO DO COMPONENTE A SER CRIADO,
      // A FUNÇAO requestNewCardPost CRIA MAINCONTENT ATUALMENTE, TROCAR PARA PEGAR DO NEWSECTION

      // LOADING
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

      // SALVANDO SKETCH
      await this.$refs.posteditorset.saveSketch()

      // ATUALIZANDO SEÇÃO ATIVA (AO CLICAR NO BOTÃO, SOMA MAIS UM PARA CRIAR A SEÇÃO ABAIXO)
      this.setPageFrameIndex(this.postBarSlotIndex + 1);

      // CRIANDO NOVA SEÇÃO COM BASE NA POSIÇÃO DO BOTÃO
      const responseApi = await this.requestNewCardPost(
        this.$session.get("siteId"),
        this.postId,
        this.postBarSlotIndex
      );

      // ATUALIZANDO POST
      const post = await this.refreshPostEditorData(this.$session.get("siteId"), this.postId);

      // CRIA OS FRAMES DA SEÇÃO
      await this.generateFrames(newSection);

      // LOADING
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
    },
    // GERA OS FRAMES DO PRESET
    async generateFrames(preset, isClone = false) {
      // PERCORRE OS FRAMES DO PRESET
      if (isClone) {
        await this.makeCloneFrame(preset);
      } else {
        await this.makePresetFrame(preset);
      }
    },
    // CLONA O FRAME
    async makeCloneFrame(preset) {
      this.isPresetFrame = true;

      let presetIndex = this.contentPost[this.postBarSlotIndex].frameContent.map(frame => frame.frameId).indexOf(preset.frameId);

      let cloneFrame = await this.requestNewFrame(
        preset.frameType,
        preset.frameContent,
        preset.grid,
        preset.gridMobile,
        null,
        presetIndex,
        preset.extra,
      );

      let cloneIndex = this.contentPost[this.postBarSlotIndex].frameContent.map(frame => frame.frameId).indexOf(cloneFrame.frameId);

      // PERCORRE OS FRAMES DO PRESET
      for (let frameIndex = 0; frameIndex < preset.frameContent.length; frameIndex++) {
        const childFrame = preset.frameContent[frameIndex];

        let frameStructure = {
          type: childFrame.frameType,
          content: childFrame.frameContent,
          grid: childFrame.grid,
          gridMobile: childFrame.gridMobile,
          extra: childFrame.extra,
          position: childFrame.position,
        };

        await this.mountNewFrame(
          frameStructure,
          true,
          null,
          cloneFrame.frameId,
          cloneIndex,
          true
        );
      }

      this.isPresetFrame = false;
    },
    async makePresetFrame(preset) {
      this.isPresetFrame = true;
      this.activeSettingsItemIndex = null;

      for (let frameIndex = 0; frameIndex < preset.frames.length; frameIndex++) {
        const frame = preset.frames[frameIndex];

        // CRIA O FRAME
        let newFrame = this.isLastNewFrame
          ? await this.requestLastNewFrame(
              frame.type,
              frame.content,
              frame.grid,
              frame.gridMobile,
              true,
              frame.extra,
              frame.width,
              frame.height
            )
          : await this.requestNewFrame(
              frame.type,
              frame.content,
              frame.grid,
              frame.gridMobile,
              null,
              frameIndex,
              frame.extra,
              frame.width,
              frame.height
            );

        // VERIFICA SE O FRAME POSSUI FRAMES FILHOS
        if (frame.frames) {
          // PERCORRE OS FRAMES FILHOS
          for (let childIndex = 0; childIndex < frame.frames.length; childIndex++) {
            const childFrame = frame.frames[childIndex];

            // CRIA O FRAME FILHO
            let indexValue = this.isLastNewFrame
              ? this.contentPost[this.postBarSlotIndex].frameContent.map(frame => frame.frameId).indexOf(newFrame.frameId)
              : frameIndex

            let frameId = this.contentPost[this.postBarSlotIndex].frameContent[indexValue].frameId;

            let frameStructure = {
              type: childFrame.type,
              content: childFrame.content,
              grid: childFrame.grid,
              gridMobile: childFrame.gridMobile,
              extra: childFrame.extra,
              position: childFrame.position,
              width: childFrame.width,
              height: childFrame.height
            };

            await this.mountNewFrame(
              frameStructure,
              true,
              null,
              frameId,
              indexValue,
              true
            );
          }
        }
      }

      this.isPresetFrame = false;
    },
    setIndexSection(index) {
      this.postBarSlotIndex = index;
      this.pageFrameIndex = this.postBarSlotIndex;
      this.$store.commit("dashboardModule/updatePageIndex", this.postBarSlotIndex);
    },
    /*
    Seta o indice do botao adicionar que foi clicado
    */
    setPostBarSlot(i, referer, card, frame, action) {
      // como o clique do botao é na parte inferior, e se tiver maincontent em cima
      // seta o valor - 1
      // botao de depois
      if (action == 'after') i = i;

      // botao de antes
      if (action == 'before') i = i - 1;

      if (referer === 'card') {
        // if (this.$refs.postbar && this.$refs.postbar[this.postBarSlotIndex]) {
        //   this.$refs.postbar[this.postBarSlotIndex].$data.active = false;
        // }

        this.postBarSlotIndex = i;
        this.pageFrameIndex = this.postBarSlotIndex;
        this.$store.commit("dashboardModule/updatePageIndex", this.postBarSlotIndex);
      }

      if (referer === 'frame') {
        // if (this.$refs.postbar && this.$refs.postbar[this.postBarSlotIndex]) {
        //   this.$refs.postbar[this.postBarSlotIndex].$data.active = false;
        // }

        // this.postBarSlotIndex = i;
        // this.pageFrameIndex = this.postBarSlotIndex;
        // this.$store.commit("dashboardModule/updatePageIndex", this.postBarSlotIndex);
      }
    },
    //Verifica se o Frame é Store
    isStore(component) {
      return component.includes('store');
    },
    // Função chamada quando clica no icone para adicionar frame
    // para adicionar no final do post
    async newFrameEvent(i, referer, card, frame, action) {
      /*
      se a pagina que vai inserir for main content
        - só pede pra adiconar frame
      senao
        - cria um card de maincontent
      */
      if (referer === 'card') {
        this.requestNewPost(i);
      } else {
        this.frameButtons[i].request();
      }
    },
    // Cria uma nova Pagina unica, limpa ele e adicionar o frame selecionado
    async requestNewPost(i) {
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
      await this.$refs.posteditorset.saveSketch()

      const responseApi = await this.requestNewCardPost(
        this.$session.get("siteId"),
        this.postId,
        this.postBarSlotIndex+1
      );
      const post = await this.refreshPostEditorData(this.$session.get("siteId"), this.postId);
      const newPost = post.data.content[this.postBarSlotIndex + 1];
      this.setPageFrameIndex(this.postBarSlotIndex + 1);
      //comentando pq nao entendi pq tirar esses post frame
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      this.frameButtons[i].request();
    },
    // Seta o pageFrameIndex no postEditor e no vuex
    setPageFrameIndex(index) {
      this.postBarSlotIndex = index;
      this.pageFrameIndex = index;
      this.$store.commit("dashboardModule/updatePageIndex", index);
    },
    //Verifica se o page frame é maincontent
    verifyIsMaincontent(pageFrame) {
      let pageMainContent = false;
      if (pageFrame.component.indexOf("maincontent") > -1) {
        pageMainContent = true;
      }
      return pageMainContent;
    },
    //Pega o item e retorna com o component da pageFrame
    selectPostItem(item) {
      this.setComponentFrame(item);
      const postItem = item.frameContent;
      return postItem;
    },
    //Add qual ao frame qual é o component da pageFrame
    setComponentFrame(item) {
      const component = item.component.split("-")[0];
      item.frameContent.forEach((element) => {
        element.component = component;
      });
    },
    //Define o pageFrameId e abre o modal de reordernar
    setSortMode(id) {
      this.pageFrameId = id;
      this.sortMode = true;
    },
    //Com o id e ele busca qual é o index do frame
    searchIndexFrameId(id) {
      for (let i = 0; i < this.contentPost.length; i++) {
        const frameID = this.contentPost[i].frameId;

        if (frameID == id) {
          this.setPageFrameIndex(i)

          return true;
        }
      }
    },
    //Abre o modal do cardInPost
    requestCardPost() {
      this.modalCard = true;
    },
    //Cria uma galeria sem conteudo
    async createNewGallery() {
      let galleryStructure = {
        text: "",
        items: [],
      };
      await this.requestNewFrame("gallery", galleryStructure, 12);
    },

    //transforma frame do tipo image em galeria
    async transformInGallery(item) {
      this.$store.dispatch("dashboardModule/TOGGLE_SIDEBAR_SETTINGS");

      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

      const picture = { url: item.frameContent };

      const gallery = [this.createPictureObject(picture)];

      const index = this.activeSettingsItemIndex;

      let galleryStructure = {
        text: "",
        items: gallery,
      };

      await this.requestNewFrame("gallery", galleryStructure, 12, 12, false, index);

      this.removePostFrame(index + 1);

      this.saveSketchEditor();

      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
    },

    //altera a posição de uma elemento na array
    changePositionIndex(arr, from, to) {
      arr.splice(to, 0, arr.splice(from, 1)[0]);
      return arr;
    },

    // Clona o frame
    async cloneThisFrame(frame, type, content, index, grid, gridMobile) {
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

      // FAZ TRATATIVA PARA GERAR O FRAME DE CONTAINER DIFERENTE
      // JA QUE ELE POSSUI FILHOS, SO O REQUEST NEW FRAME NAO RESOLVERIA
      if (type === "container") {
        await this.generateFrames(frame, true);
      } else {
        await this.requestNewFrame(type, content, grid, gridMobile, true, index);
      }

      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
    },

    // Altera ao clicar entre o col-12,6 e 4 do frame ativo
    // se for 2 framecontent, organiza para ficar sempre col-12 a linha ou 2 linhas de col-12
    changeGrid(item, keyOfItem, postItem) {
      let grid = item.grid
      // if necessario porque também pode ser alterado na config do frame
      if (grid <= 12 && grid > 6) {
        item.grid = 6
      } else if (grid <= 6 && grid > 4) {
        item.grid = 4
      } else {
        item.grid = 12
      }

      // se só tiver 2 items como um about, nao ficar deixando ter um col-7 e um col-12
      if (postItem.frameContent.length == 2) {
        let anotherKeyOfFrame = keyOfItem == 1 ? 0 : 1;
        postItem.frameContent[anotherKeyOfFrame].grid = item.grid == 12 ? 12 : 12 - item.grid;
      }

      return item.grid;
    },

    // Abre o PostEditorSetting para salvar o rascunho
    saveSketchEditor() {
      if (this.step == 1) {
        this.openSaveSketch = true;
        this.oldVal = this.newVal;
        this.$refs.posteditorset.saveSketch()
      }
    },

    // Seleciona a grid do post que será mostrada no editor. Home, title, contact mostrar 100%
    selectGrid(postItem) {
      let grid = "col-12";

      if (postItem.grid == 99) {
        return "col-12";
      }

      if (postItem.component == 'contact'
         || postItem.component == 'home'
         || postItem.component == 'comments') {

        if (postItem.component == 'contact'
            && !['form', 'container','title','comments'].includes(postItem.frameType)) {
            return "col-12 col-md-6"
        }

        return grid;
      }
      if (postItem.grid) {
        return `col-${postItem.grid}`;
      } else {
        return grid;
      }
    },

    //Request para trazer o css do siteClient
    async getLayout() {
      const url = `/site/${this.$session.get("siteId")}/client/layout`;
      let post = await this.requestApiData(url, "get");
      let siteCss = JSON.parse(post.content.data);
      this.$store.dispatch("dashboardModule/POPULATESITECSS", siteCss);
    },
    previousStep() {
      this.openSaveSketch = false;
      this.savingLoading = false;
      if (this.step > 1) {
        this.step--;
        setTimeout(() => {
          this.saveSketchEditor();
        }, 30);
      } else {
        this.confirmExit();
      }
    },
    // Pula a etada de config e publica com os config existentes ou geradas automaticas
    stepSave() {
      this.confirmBlankPost();
      if (!this.isBlankPost) {
        console.log('type', this.postType)
        if (!this.published.published_at && this.postType == "post") {
          this.$bvModal.hide("preview-modal");
          this.nextStep();
        } else {
          this.step = 3;
          this.openSaveSketch = true;
          this.$refs.posteditorset.savePost()
        }
      }
    },
    nextStep() {
      this.confirmBlankPost();
      if (!this.isBlankPost) {
        this.step++;
        this.openSaveSketch = true;
      }
    },
    scrollToId(id) {
      setTimeout(() => {
        var element_to_scroll_to = document.getElementById("postEditor");
        var element_to_scroll_to = document.querySelectorAll(
          `#FrameContainer-${id}`
        )[0];
        element_to_scroll_to.scrollIntoView();
      }, 100);
    },
    createPictureObject(picture) {
      let data = "";
      if (picture.dataCreate) {
        data = picture.dataCreate;
      } else {
        var d = new Date(),
          dformat =
            [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        data = dformat;
      }
      return {
        button: null,
        buttonText: "",
        buttonList: [],
        href: null,
        image: {
          alt: null,
          height: null,
          url: picture.url,
          width: null,
          createdAt: data,
        },
        focalPoint: {
          x: 50,
          y: 50,
        },
        page: null,
        sloganShow: true,
        subtitle: "",
        target: "_self",
        title: "",
        type: "image",
      };
    },
    async itemUpdatedGallery(item) {
      // PEGA A GALERIA QUE ESTA SENDO FEITO A ALTERAÇÃO
      let itemUpdated = this.contentPost[this.pageFrameIndex].frameContent[
        this.galleryRequestedMediaManager
      ].frameContent;

      // VERIFICA SE ESTA ALTERANDO A GALERIA INTEIRA OU APENAS UM ITEM/IMAGEM DELA
      if (!this.isChangePicture) {
        // SE NENHUMA IMAGEM ESTIVER DEFINIDA PARA A MUDANÇA

        // ADICIONA OS ITENS ESCOLHIDOS NA GALERIA
        itemUpdated.items = [...itemUpdated.items, ...item].flat();
      } else {
        // SE EXISTIR IMAGEM DEFINIDA PARA A MUDANÇA

        // PEGA O ITEM/IMAGEM E SUBSTITUI A URL PELA NOVA ESCOLHIDA
        itemUpdated.items[this.pictureForChange].image.url = item[0].image.url

        if (item[0].embed) {
          itemUpdated.items[this.pictureForChange].embed = item[0].embed
        }

        // DEFINE QUE NÃO TEM MAIS IMAGEM INDIVIDUAL PARA ALTERAÇÃO
        this.pictureForChange = null
        this.isChangePicture = false;
      }

      // ATUALIZA STORE COM AS NOVAS IMAGENS
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
        this.pageFrameIndex,
        this.galleryRequestedMediaManager,
        itemUpdated,
      ]);
    },
    setPageFrameId(id) {
        this.pageFrameId = id;
    },
    async addPictures(pictures) {
      if (this.newGallery && !this.isChangePicture) {
        await this.handleUpdatePicture(pictures);
        this.newGallery = false;
        this.isLastNewFrame = false;
      } else {
        pictures = pictures.map(this.createPictureObject);
        await this.itemUpdatedGallery(pictures);
        this.showMediaManager = false;
        this.pageFrameId && this.scrollToSection(this.pageFrameId);
      }

      this.maxItemSelected = 200;
    },
    createVideoObject(data) {
      var autoPlayType = false;
      var expandType = true;
      if (this.postType != "post") {
        autoPlayType = true;
      }
      if (this.postType == "home") {
        expandType = false;
      }
      return {
        button: null,
        buttonText: "",
        buttonList: [],
        href: null,
        image: {
          alt: null,
          height: null,
          url: data.url,
          width: null,
        },
        focalPoint: {
          x: 50,
          y: 50,
        },
        page: null,
        sloganShow: true,
        subtitle: "",
        embed: data.embed,
        target: "_self",
        title: "",
        type: "video",
        autoplay: autoPlayType,
        expand: expandType,
      };
    },
    async addVideo(data) {
      if (this.newGallery) {
        await this.handleUpdateVideos(data);
        this.newGallery = false;
      } else {
        data = data.map(this.createVideoObject);
        await this.itemUpdatedGallery(data);
        this.showMediaManager = false;
        this.pageFrameId && this.scrollToSection(this.pageFrameId);
      }
    },
    openMediaManager(index, id, content) {
      this.setPageFrameId(id);
      this.activeContent = [];
      this.searchIndexFrameId(id);
      this.galleryRequestedMediaManager = index;
      this.showMediaManager = true;
      if (content) {
        this.activeContent = content.items;
      } else {
        this.contentPost.forEach((frame) => {
          frame.frameContent.forEach((content) => {
            if (content.frameType == "gallery") {
              content.frameContent.items.forEach((item) => {
                if (item.type == "image") {
                  this.activeContent.push(item);
                }
              });
            }
          });
        });
      }
    },
    async createFrameVideo() {
      let linkVideo = this.$refs.urlVideo.value
      this.loadingVideo = true;
      if (this.checkUrlIsVideoOfInstagram(linkVideo)) {
        var content = this.getContentOfEmbedOfInstagram(linkVideo);
        let dataVideo = this.requestNewIndexedFrame("script", content);
      } else {
        const uri = { uri: linkVideo };
        const url = `/site/${this.$session.get("siteId")}/post/${
          this.postId
        }/video/link`;
        let dataVideo = await this.requestApiData(url, "post", uri);
        if (dataVideo.status === "1") {
          let content = {
            embed: dataVideo.embed,
            thumbnail: dataVideo.thumbnail,
          };
          this.requestNewIndexedFrame("video", content);
        } else alert("Erro ao validar video. Tente novamente")
      }
      this.loadingVideo = false;
      this.$refs.modalVideo.hide();
      this.$refs.urlVideo.value = "";
    },
    changeImageFromGallery(indexPicture, parentId, gallery, indexGallery) {
      this.maxItemSelected = 1;
      this.isChangePicture = true;
      this.pictureForChange = indexPicture;

      this.openMediaManager(
        indexGallery,
        parentId,
        gallery.items
      );
    },
    openSettingsFrameChild(indexChild, postItem, indexParent, sectionId) {
      this.setActiveFrame(postItem, indexParent, sectionId);

      this.activeSettingsItemChildIndex = indexChild;

      this.$store.dispatch("dashboardModule/TOGGLE_SIDEBAR_SETTINGS");
    },
    deleteFrameChild(indexChild, postItem, indexParent, sectionId) {
      this.setActiveFrame(postItem, indexParent, sectionId);

      this.removeChildFrame(indexChild, indexParent);
    },
    /* funcao que dispara quando percebe no texto que colou um link do youtube / vimeo */
    async changeTextToVideo(event, item, index) {
      var returnApi = false
      if (this.checkUrlIsVideoOfVimeo(event)) {
        returnApi = await this.getContentOfEmbedVimeo(
          event,
          this.$session.get("siteId"),
          this.postId
        );
      } else if (this.checkUrlIsVideoOfYoutube(event)) {
        returnApi = await this.getContentOfEmbedYoutube(
          event,
          this.$session.get("siteId"),
          this.postId
        );
      }

      if (returnApi) {
        const frameContent = {
          embed: this.checkReplaceEmbedIfYoutube(returnApi.embed),
          thumbnail: returnApi.thumbnail,
        };

        item.frameType = "video";
        item.frameContent = frameContent;
        this.$store.dispatch("dashboardModule/UPDATE_FRAME", [index, item]);
      }
    },
    async changeTextToMusic(event, item, index) {
      const soundcloudMatch = event.match(/soundcloud/g);

      if (soundcloudMatch !== null) {
        axios
          .get(
            `http://soundcloud.com/oembed?format=js&url=${event}&iframe=true`
          )
          .then((response) => {
            const parsedResponse = JSON.parse(response.data.slice(1, -2));
            item.frameType = "music";
            item.frameContent = {
              embed: parsedResponse.html,
              thumbnail: parsedResponse.thumbnail_url,
            };
          })
          .catch((err) => {
            alert(
              "Link do Soundcloud não encontrado, verifique o link e tente novamente"
            );
            console.log(err);
          });
      } else {
        if (event.slice(0, 8) !== "https://") {
          event = "https://" + event;
        }

        const mediaType = event.match(
          /track|playlist|album|show|user|artist|episode/gm
        );
        if (mediaType) {
          item.frameType = "music";
          item.frameContent = {
            embed: event.replace(mediaType[0], `embed/${mediaType[0]}`),
            thumbnail: null,
          };
        }
      }
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [index, item]);
    },
    getExt(str) {
      if (str) {
        str = str.toLowerCase().split(".");
        return str[str.length - 1];
      } else {
        return null;
      }
    },
    getUrl(picture) {
      let fitIn = "";
      if (this.fitIn) {
        fitIn = `${this.fitIn}/`;
      }
      if (this.getExt(picture) == "svg" || this.getExt(picture) == "gif") {
        return `${process.env.CONTAINER_URL}${picture}`;
      }
      return `${process.env.CDN_URL}${fitIn}${picture}`;
    },
    async handleUpdatePicture(files) {
      if (files.length > 0) {
        let pictures = files;
        if (pictures.length == 2) {
          for (let i = 0; i < pictures.length; i = i + 1) {
            const gridSize = 6;
            this.requestNewIndexedFrame("image", pictures[i].url, gridSize, pictures[i].width, pictures[i].height);
          }
        } else if (pictures.length > 2) {
          let gallery = pictures.map(this.createPictureObject);
          let galleryStructure = {
            text: "",
            items: gallery,
          };
          this.requestNewIndexedFrame("gallery", galleryStructure);
        } else {
          let gridSize = 12;

          // VERIFICA SE O WIDTH E HEIGHT ESTÃO DEFINIDOS (VEM DEFINIDO QUANDO ACABA DE FAZER UPLOAD)
          // TODO: FAZER A API RETORNAR ESSAS INFORMAÇÕES PARA NÃO TER QUE FAZER ESSA VERIFICAÇÃO
          if (pictures[0].width && pictures[0].height) {
            gridSize = parseInt(pictures[0].width) >= parseInt(pictures[0].height) ? 12 : 6;
          } else {
            // SE NÃO TIVER DEFINIDO, FAZ UMA REQUISIÇÃO PARA PEGAR O TAMANHO DA IMAGEM COM BASE NA URL
            gridSize = await this.calculateGridSize(
              this.getUrl(pictures[0].url)
            );
          }
          this.requestNewIndexedFrame("image", pictures[0].url, gridSize, pictures[0].width, pictures[0].height);
        }
      } else {
        alert("Nenhum arquivo selecionado.");
      }
      this.showMediaManager = false;
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      this.$data.fileProgressShow = false;
    },
    async handleUpdateVideos(files) {
      if (files.length > 0) {
        let videos = files;
        if (videos.length < 3) {
          videos.map(async (video) => {
            let dataVideo = this.createVideoObject(video);

            let content = {
              embed: dataVideo.embed,
              thumbnail: dataVideo.image.url,
            };

            await this.requestNewIndexedFrame("video", content);
          });
        } else {
          let gallery = videos.map(this.createVideoObject);

          let galleryStructure = {
            text: "",
            items: gallery
          };

          await this.requestNewIndexedFrame("gallery", galleryStructure);
        }
      } else {
        alert("Nenhum video selecionado.");
      }

      this.showMediaManager = false;
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      this.$data.fileProgressShow = false;
    },
    async apiGetPost(postId) {
      const post = await this.refreshPostEditorData(this.$session.get("siteId"), postId)

      //nao consegui fazer funcionar na mixin
      post.data.content = post.data.content.map(this.createScriptProperty);
      this.$store.dispatch("dashboardModule/getPostData", [post.data]);
      //fix de timeout pois o postedditor precisa do getPostData e como é async pode nao ter chegado na store a info
      setTimeout(() => {
        this.$refs.posteditorset.moutedSettings()
      }, 1000);
    },
    createScriptProperty(content) {
      if (content.frameType == "script") {
        content.runCode = true;
      }
      return content;
    },
    calculateGrid(gridValue) {
      if (gridValue == 99) {
        return "col-12";
      }

      return `col-${gridValue}`;
    },
    showSettings(frameType) {
      const allowSetingsFrames = ["image", "button", "beforeAfterImage"];
      if (allowSetingsFrames.some((item) => item === frameType)) {
        return true;
      }
      return false;
    },
    /* função que importa o conteudo do instagram */
    async importSocialMediaContent() {
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);

      const url = `/site/${this.$session.get(
        "siteId"
      )}/image/upload/url?postId=${this.postId}`;
      let formData = new FormData();
      formData.append("postList", JSON.stringify(this.selectedMedias));
      formData.append("index", this.postBarSlotIndex);
      const socialMediaContentUploaded = await this.requestApiData(
        url,
        "post",
        formData
      );
      //location.reload();
      this.refreshPostEditorData(this.$session.get("siteId"), this.postId);

      this.importMode = false;
      setTimeout(() => {
        console.log(socialMediaContentUploaded.createdFrames[0])
        this.scrollToId(socialMediaContentUploaded.createdFrames[0])
      }, 1000)
    },
    uploadSocialMediaContent(medias) {
      return new Promise((resolve, reject) => {
        const url = `/site/${this.$session.get(
          "siteId"
        )}/image/upload/url?postId=${this.postId}`;
        let formData = new FormData();
        formData.append("postList", JSON.stringify(medias));
        const returnApi = this.requestApiData(url, "post", formData);
        resolve(true);
      });
    },
    confirmRemoveFrame(index, id, type = "frame", dataId) {
      this.searchIndexFrameId(id);
      if (type == "frame") {
        if (this.ckeckClearTextFrame(index)) {
          this.removePostFrame(index);
        } else {
          this.modalDelete(index, type, dataId);
        }
      } else {
        this.modalDelete(index, type, dataId);
      }
    },
    externalTestimonyRequest(frameId) {
      this.$refs.modalTestimony.show();
      this.testimonyLink = `${this.getSiteLink}/depoimento/enviar?frameId=${frameId}`;
    },
    copyLink() {
      var copyText = document.getElementById("linkTestimony");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
    },
    modalDelete(index, type, dataId) {
      const message = type == "frame"
        ? "Deseja realmente remover este conteúdo?"
        : "Deseja realmente remover esta seção?";

      let h = this.$createElement
      const messageVNode = h('div', { class: [alert] }, [
        h('p',{ class: [''] },
          message
        )
      ])
      this.$bvModal
        .msgBoxConfirm(messageVNode, {
          title: "Confirmar exclusão",
          size: "md",
          buttonSize: "sm",
          cancelVariant: "primary",
          okVariant: "danger",
          okTitle: "Remover",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            if (type == "frame") {
              this.removePostFrame(index);
            } else if (type == "page") {
              this.removePageFrame(this.pageFrameIndex, dataId);
            }
            else {
              console.log('delete else')
            }
          }
        });
    },


    confirmCloneFrame(frame, frameType, frameContent, frameId, index, postItem) {
      this.searchIndexFrameId(frameId);
      this.$bvModal
        .msgBoxConfirm("Deseja realmente duplicar este conteúdo?", {
          title: "Duplicar",
          size: "md",
          buttonSize: "sm",
          cancelVariant: "danger",
          okTitle: "Confirmar",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.cloneThisFrame(frame, frameType, frameContent, index, postItem.grid, postItem.gridMobile);
          }
        });
    },
    ckeckClearTextFrame(index) {
      const clearText =
        this.contentPost[this.pageFrameIndex].frameContent[index].frameContent;
      const frameType =
        this.contentPost[this.pageFrameIndex].frameContent[index].frameType;
      return (
        frameType == "text" &&
        (clearText == null || clearText == "<p><br></p>" || clearText == "")
      );
    },
    removeChildFrame(indexChild, indexParent) {
      this.deletedFrames.push(
        this.contentPost[this.pageFrameIndex].frameContent[indexParent].frameContent[indexChild]
      )

      this.$store.dispatch("dashboardModule/removeChildFrame", [
        indexChild,
        indexParent,
      ]);
    },
    removePostFrame(index) {
      this.deletedFrames.push(
        this.contentPost[this.pageFrameIndex].frameContent[index]
      );
      this.$store.dispatch("dashboardModule/removePostFrame", [index]);
    },
    removePageFrame(index, id) {
      const url = `/site/${this.$session.get("siteId")}/post/${
        this.postId
      }/card/${id}`;
      const responseApi = this.requestApiData(url, "delete");
      this.$store.dispatch("dashboardModule/removePageFrame", [index]);
    },
    confirmBlankPost() {
      this.isBlankPost = this.checkBlankPost();
      if (this.isBlankPost) {
        this.$bvModal.msgBoxOk(`Por favor insira conteúdo para continuar.`, {
          title: "Post em branco.",
          modalClass: "full-white",
          size: "md",
          buttonSize: "sm",
          okTitle: "OK",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
          noCloseOnBackdrop: true,
        });
      }
    },
    confirmExit() {
      this.$bvModal
        // .msgBoxConfirm("Todas as alterações serão perdidas.", {
        .msgBoxConfirm("Algumas alterações podem ser perdidas.", {
          title: "Sair do editor?",
          modalClass: "full-white",
          size: "md",
          buttonSize: "sm",
          cancelVariant: "default",
          okTitle: "Sair",
          cancelTitle: "Voltar",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isBlankPost = this.checkBlankPost();
            this.handleExit(this.isBlankPost);
          }
        });
    },
    checkBlankPost() {
      const titleAndText = this.contentPost[0].frameContent.filter(
        (item) => item.frameType === "title" || item.frameType === "text"
      );
      if (titleAndText.length === this.contentPost[0].frameContent.length) {
        return titleAndText.every(
          (item) => item.frameContent == null || item.frameContent.length < 1
        );
      }
      return false;
    },
    async handleExit(isBlankPost) {
      if (isBlankPost) {
        this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
        const url = `/site/${this.siteId}/post/${this.postId}/delete`;
        const deletedPost = await this.requestApiData(url, "post");
        this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      }
      this.$store.dispatch("dashboardModule/CLEAR_ACTIVE_POST");
      this.$router.push("/dashboard");
    },
    async calculateGridSize(completeUrl) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        var gridSize = 12;

        img.onload = function() {
          if (this.width <= this.height) {
            gridSize = 6;
          }

          resolve(gridSize);
        };

        img.onerror = function() {
          reject(new Error("Erro ao carregar a imagem."));
        };

        img.src = completeUrl;
      });
    },
    async requestLastNewFrame(
      type,
      content = "",
      grid = 12,
      gridMobile = 12,
      scrollToId = true,
      extra = null,
      indexParent = null,
      width = null,
      height = null
    ) {
      if (type == 'container') {
        content = [];
      }

      let parentId = null;

      if (this.activeSettingsItemIndex != null) {
        indexParent = this.activeSettingsItemIndex;
      }

      if (indexParent != null) {
        parentId = this.contentPost[this.postBarSlotIndex].frameContent[indexParent].frameId;
      }

      const newFrame = indexParent == null
        ? await this.mountNewFrame(
            {
              type: type,
              content: content,
              grid: grid,
              gridMobile: gridMobile,
              extra: extra,
              width: width,
              height: height
            },
            scrollToId,
            this.contentPost[this.postBarSlotIndex].frameContent.length,
            null,
            null,
            false
          )
        : await this.mountNewFrame(
            {
              type: type,
              content: content,
              grid: grid,
              gridMobile: gridMobile,
              extra: extra,
              width: width,
              height: height
            },
            scrollToId,
            this.contentPost[this.postBarSlotIndex].frameContent[indexParent].frameContent.length,
            parentId,
            indexParent,
            true
          );

      this.activeSettingsItemIndex = null;

      return newFrame
    },
    async requestNewFrame(
      type,
      content = "",
      grid = 12,
      gridMobile = 12,
      scrollToId = true,
      index = null,
      extra = null,
      width = null,
      height = null
    ) {

      if (type == 'container') {
        content = [];
      }

      if (index == null && this.postBarSlotIndex) {
        index = this.postBarSlotIndex;
      }

      if (type == "page") {
        this.modalCard = false;
      }
      // const pushFrameAfterNewFrame = this.ckeckClearTextFrame(
      //   this.contentPost[this.pageFrameIndex].frameContent.length - 1
      // );
      const pushFrameAfterNewFrame = false;

      if (pushFrameAfterNewFrame) {
        this.removePostFrame(
          this.contentPost[this.pageFrameIndex].frameContent.length - 1
        );
      }

      const newFrame = await this.mountNewFrame({type: type, content: content, grid: grid, gridMobile: gridMobile, extra: extra, width: width, height: height}, scrollToId, index);

      if (pushFrameAfterNewFrame && (type == "image" || type == "gallery")) {
        setTimeout(() => {
          this.mountNewFrame({type: "text", content: content, gird: 12, gridMobile: 12});
        }, 1000);
      }

      return newFrame
    },
    async requestNewIndexedFrame(type, content="", grid = 12, width = null, height = null) {
      if (type == "page") {
        this.modalCard = false;
      }

      if (this.isLastNewFrame) {
        await this.requestLastNewFrame(type, content, grid, 12, true, null, null, width, height);
      } else {
        await this.requestNewFrame(type, content, grid);
      }

      this.postBarSlotIndex = 0
    },
    async mountNewFrame(
      frameStructure,
      scrollToId,
      index = null,
      parentId = null,
      indexParent = null,
      isChild = false
    ) {
      const generateId = await this.generateId(frameStructure.type, this.postBarSlotIndex, frameStructure.content, parentId);

      let newPostFrame = {
        action: null,
        actionType: 0,
        frameId: generateId?.frameId,
        frameDataId: generateId?.frameDataId,
        frameType: frameStructure.type,
        frameContent: frameStructure.content,
        extra: frameStructure.extra ? frameStructure.extra : null,
        frameStatus: 1,
        grid: frameStructure.grid,
        gridMobile: frameStructure.gridMobile,
        index: index,
        indexParent: indexParent,
        position: frameStructure.position,
      };

      // DEFININDO VARIAVEIS EXTRA
      if (!frameStructure.extra) {
        switch (frameStructure.type) {
          case 'text':
            newPostFrame.extra = {
              'margin_mobile_lock': true,
              'margin': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'margin_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile_lock': true,
              'padding': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'background_image': '',
              'background_image_focal_point': {
                'x': 50,
                'y': 50,
              },
              'background_image_opacity': 80,
            }
          break;

          case 'gallery':
            newPostFrame.extra = {
              'margin_mobile_lock': true,
              'margin': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'margin_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile_lock': true,
              'padding': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'maincontent_gallery_id': 0,
              'maincontent_gallery': 'gallery-default',
            }
          break;

          case 'container':
            newPostFrame.frameContent = [];
            newPostFrame.extra = {
              'vertical_align': 'start'
            }
          break;

          case 'image':
            newPostFrame.width = frameStructure.width;
            newPostFrame.height = frameStructure.height;
            newPostFrame.extra = {
              'margin_mobile_lock': true,
              'margin': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'margin_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile_lock': true,
              'padding': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'style_width_lock': true,
              'style_height_lock': true,
              'style': {
                'borderRadius': '0px',
                'width': '64px',
                'height': '64px',
              }
            }
          break;

          case 'title':
            newPostFrame.extra = {
              'margin_mobile_lock': true,
              'margin': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'margin_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile_lock': true,
              'padding': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'padding_mobile': {
                'top': 0,
                'bottom': 0,
                'left': 0,
                'right': 0
              },
              'style_font_size_lock': true,
              'style_font_weight_lock': true,
              'style_text_align_lock': true,
              'style': {
                'fontSize': '16px',
                'fontWeight': '700',
                'textAlign': 'left',
                'color': ''
              }
            }
          break;

          case 'button':
            newPostFrame.extra = {
              'style_font_size_lock': true,
              'style_font_weight_lock': true,
              'style_border_radius_lock': true,
              'style_text_align_lock': true,
              'style': {
                'fontSize': '16px',
                'fontWeight': '700',
                'textAlign': 'left',
                'color': '',
                'backgroundColor': '',
                'borderRadius': '0px',
              }
            }
          break;

          default:
            newPostFrame.extra = newPostFrame.extra
          break;
        }
      }

      if (frameStructure.type == "script") {
        newPostFrame.runCode = false;
      }

      if (!isChild) {
        // this.$store.dispatch("dashboardModule/addPostFrame", [
        //   newPostFrame,
        //   this.pageFrameIndex,
        // ]);
        this.$store.dispatch("dashboardModule/pushNewPostFrame", [newPostFrame]);
      } else {
        this.$store.dispatch("dashboardModule/addChildFrame", [newPostFrame]);
      }

      if (scrollToId) {
        this.scrollToId(newPostFrame.frameId);
      }

      if (frameStructure.type == "image" && this.totalPost.thumbnail.mainImage == null) {
        this.totalPost.thumbnail.mainImage = frameStructure.content;
      }
      if (frameStructure.type == "video" && this.totalPost.thumbnail.mainImage == null) {
        this.totalPost.thumbnail.mainImage = frameStructure.content.thumbnail;
      }
      if (frameStructure.type == "gallery" && this.totalPost.thumbnail.mainImage == null) {
        this.totalPost.thumbnail.mainImage = frameStructure.content[0];
      }

      if (parentId != null) {
        return newPostFrame
      } else {
        return generateId
      }
    },
    // Gera o ID de frameId e frameDataId
    async generateId(type, index, content="", parentId = null) {
      let formData = new FormData();
      formData.append("postId", this.postId);

      if (parentId != null) {
        formData.append("parentId", parentId);
      }

      if (this.isPresetFrame) {
        formData.append("isPresetFrame", true);
      }

      formData.append(
        "cardId",
        this.contentPost[this.pageFrameIndex].frameDataId
      );
      index ? formData.append("index", index) : null;

      if (typeof content == 'object') {
        content ? formData.append("embed", content.embed) : null;
        content ? formData.append("thumbnail", content.thumbnail) : null;
      } else if (content.includes("uploads/site")) {
        content ? formData.append("url", content) : null;
      }

      const url = `/site/${this.siteId}/post/${this.postId}/frame/create/${type}`;
      const responseApi = await this.requestApiData(url, "post", formData);
      return responseApi;
    },

    openSettingsPageFrame(item, index) {
      // TODO: FAZER ABRIR A SIDEBAR DE SETTINGS
      // this.$store.dispatch("dashboardModule/TOGGLE_SIDEBAR_SETTINGS");

      // this.configsReference = item.frameType;

      this.activeSettingsPageFrame = item;
      this.setPageFrameIndex(index);

      this.settingsPageFrameModal = true;
    },

    // ABRE A MODAL DE CONFIGURAÇÕES
    // -> MODELO ANTIGO (FUNCIONA PARA OS DEMAIS COMPONENTES QUE NÃO SEJAM MAINCONTENT)
    openModalSettings(item, index, id) {
      this.searchIndexFrameId(id);
      this.activeSettingsItemIndex = index;
      this.activeSettingsItem = item;

      this.settingsItemModal = true;
    },
    setActiveFrame(item, index, id) {
      this.activeSettingsItemChildIndex = null;

      this.configsReference = item.frameType;

      this.searchIndexFrameId(id);
      this.activeSettingsItemIndex = index;
      this.activeSettingsItem = item;
    },
    // ABRE A SIDEBAR DE CONFIGURAÇÕES
    // -> MODELO NOVO (FUNCIONA PARA MAINCONTENT)
    openSettings(item, index, id) {
      this.setActiveFrame(item, index, id);

      this.$store.dispatch("dashboardModule/TOGGLE_SIDEBAR_SETTINGS");
    },

    toggleRunScript(item, index) {
      if (item.runCode == undefined) {
        this.$set(item, "runCode", true);
      }
      item.runCode = !item.runCode;
      if (item.runCode == true) {
        if (window.instgrm) {
          setTimeout(() => {
            window.instgrm.Embeds.process();
          }, 100);
        }
      }
    },
  },
  async created() {
    this.$store.dispatch("dashboardModule/UPDATE_FRAME_VARIABLES", await this.fetchFrameVariables());
    this.$store.dispatch("dashboardModule/UPDATE_TEMPLATE_ORGANISMS_COMBINATIONS", await this.fetchTemplateOrganismsCombinations());
    this.$store.dispatch("dashboardModule/UPDATE_SECTIONS", await this.fetchSections());

    this.apiGetPost(this.postId);
    this.$store.dispatch("VERIFY_SITE");
    // popula variavel site css
    await this.getLayout();

    this.verificationChanges = setInterval(() => {
      if (this.step == 1 && this.newVal !== this.oldVal) {
        this.saveSketchEditor();
      }
    }, 30000);

    // precisa ser depois do getLayout
    this.layoutStyles = this.getLayoutStyles;
  },
  destroyed() {
    clearInterval(this.verificationChanges);
  },
};
</script>

<style>
.saveDisplay {
    width: auto;
    padding: 0.5rem 1rem;
    z-index: 5000;
}

.btn-preview {
    background-color: var(--light);
    color: var(--main-color);
    font-weight: 400;
}

.btn-primario.btn-preview:hover {
    background-color: var(--main-color)!important;
    color: #FFFFFF;
    filter: none;
}
.card-editor {
  padding: 0 30px 60px 30px;
}

.card-editor:has(.add-last-frame) {
  padding-bottom: 100px;
}

.button-add {
  background-color: #fff;
  border: 2px solid #ccc;
  width: 32px;
  height: 32px;
  color: #ccc;
  border-radius: 50%;
  position: absolute;
  z-index: 99;
}

.button-add:hover {
  border-color: var(--main-color);
  color: #fff;
  background-color: var(--main-color);
}

.button-add.button-add--top {
  left: 50%;
  transform: translateX(-50%);
}

.button-add.button-add--bottom {
  left: 50%;
  transform: translateX(-50%);
}

.button-add.button-add--left {
  top: 50%;
  transform: translateY(-50%);
}

.button-add.button-add--right {
  top: 50%;
  transform: translateY(-50%);
}

.editor-wrapper {
  box-shadow: 0 6px 40px 1px #dedede;
}

.container-button-add {
  position: absolute;
}

.container-button-add--top {
  top: -15px;
  height: 28px;
  left: 0;
  right: 0;
}

.container-button-add--bottom {
  bottom: -15px;
  height: 28px;
  left: 0;
  right: 0;
}

.container-button-add--left {
  left: -15px;
  width: 28px;
  top: 0;
  bottom: 0;
}

.container-button-add--right {
  right: -14px;
  width: 28px;
  top: 0;
  bottom: 0;
}

.container-button-add:hover .button-add--frame {
  display: block;
}

.button-add--popover {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 99;
  background-color: var(--light);
  border-radius: 5px;
  padding: 5px 10px;
  box-shadow: 0 6px 20px 1px #dedede;
}

.button-add--popover--top {
  left: 50%;
  transform: translateX(-50%);
}

.button-add--popover--left {
  top: 50%;
  transform: translateY(-50%);
}

.button-add--popover--right {
  left: -23px;
  top: 50%;
  transform: translateY(-50%);
}

.next-step-text {
  color: white;
  font-weight: 700;
}
.item-settings-button {
  border: none;
}
.save-step-text {
  font-size: 11px;
  font-weight: 400;
  background-color: rgb(248 248 250);
  /* background-color: rgb(248 248 250 / 50%); */
  color: #707070;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
}
.total-post-editor,
.total-post-settings {
  flex-direction: row;
  display: flex;
  justify-content: center;
}
.total-post-editor .container-editor,
.total-post-settings .container-editor {
  width: 90%;
}
.total-post-settings .container-editor {
  margin-top: 52px;
}

.post-item {
  cursor: pointer;
  position: relative;
  min-height: 70px;
  transition: all 300ms;
  border: 2px  solid #ddd;
}

.text-frame-editor {
  cursor: text;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 1rem;
}

.draft-text-frame-editor {
  stroke: #dddddd;
}

.text-frame-editor:focus, .text-frame-editor:hover {
  border: 1px solid var(--main-color);
}

.post-item:focus, .post-item:hover {
  /* background-color: #fff;
  -webkit-box-shadow: 0 6px 40px 1px #dedede;
  box-shadow: 0 6px 40px 1px #dedede; */
  border: 2px solid var(--main-color);
}

.post-item:focus.draggable {
  cursor: move;
}

.text-frame-editor:focus ~ .draft-text-frame-editor, .text-frame-editor:hover ~ .draft-text-frame-editor {
  stroke: var(--main-color);
}

.post-item .item-settings {
  position: absolute;
  z-index: 2;
  right: 20px;
  top: 5px;
  color: white;
  opacity: 0;
  transition: all 300ms;
  display: flex;
  justify-content: end;
  align-items: center;
}
.post-item:focus .item-settings, .post-item:hover .item-settings {
  opacity: 1;
}

.post-item:focus .container-button-add .button-add--frame {
  display: block;
}

.container-buttons-tools {
  display: flex;
  justify-content: center;
  align-items: center;
}

.total-post-editor {
  margin-top: 90px;
}

.container-buttons {
  width: 100%;
  background-color: #f8f8fa;
}
.container-buttons-tool {
  display: flex;
  justify-content: center;
}
.container-buttons .bottom-button {
  background-color: #eeeeee;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 300ms;
}
.container-buttons .bottom-button:hover {
  background-color: #cccccc;
}

@media (max-width: 998px) {
  .editor-wrapper {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.container-step {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  justify-content: space-between;
}
.draggable-content,
.import-content {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  overflow-y: auto;
}
.draggable-content h5 {
  font-size: 13px;
}
.modal-footer {
  justify-content: space-between;
}
.slide-down-fade-enter-active {
  transition: all 0.6s ease;
}
.slide-down-fade-leave-active {
  transition: all 0.8s ease;
}
.slide-down-fade-enter {
  transform: translateY(0px);
}
.slide-down-fade-leave-active {
  transform: translateY(1000px);
}
.before-after-content img {
  min-height: 180px;
}

@media all and (min-width: 998px) {
  .total-post-editor .container-editor,
  .total-post-settings .container-editor {
    width: 885px;
  }
  .card-editor {
    padding-bottom: 40px;
  }
  .container-buttons {
    font-size: 1.3rem;
    justify-content: center;
  }
}

@media all and (min-width: 1200px) {
  .total-post-editor .container-editor,
  .total-post-settings .container-editor {
    width: 1140px;
  }

  .card-editor {
    padding-bottom: 50px;
  }
}

@media (max-width: 576px) {
  .container-fluid {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
}
.titulo--post {
  font-size: 1.5rem;
  font-weight: 600;
  color: #495057;
  font-family: "Montserrat", sans-serif;
}
.tooltip {
  position: absolute !important;
}
@media only screen and (max-device-width: 768px) {
  .tooltip {
    display: none !important;
  }
  .total-post-editor .container-buttons {
    overflow-x: auto;
  }
}
i.disabled {
  opacity: 0.2
}

.container-setting-button:hover .alert-settings {
  display: none;
}

.card-settings {
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.alert-settings {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--main-color);
  border: 1px solid #cecece;
}

.on-draggable {
  z-index: 9999;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background: #fefefe;
  color: var(--main-color);
  padding: 8px 12px;
  border-radius: 50%;
}

.on-draggable.up {
  animation: up-draggable 1s infinite;
  top: 3px;
}

.on-draggable.down {
  animation: down-draggable 1s infinite;
  bottom: 3px;
}

@keyframes up-draggable {
  0% {
    top: 3px;
  }
  50% {
    top: 8px;
  }
  100% {
    top: 3px;
  }
}

@keyframes down-draggable {
  0% {
    bottom: 3px;
  }
  50% {
    bottom: 8px;
  }
  100% {
    bottom: 3px;
  }
}

.add-last-frame--frame-container {
  opacity: 0;
  transition: all 300ms ease-in-out;
}

.post-item:hover .add-last-frame--frame-container {
  opacity: 1;
  transition: all 300ms ease-in-out;
}

div:has( > .modal-delete-medias) {
  z-index: 9999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/PostEditor.vue